import AES from 'crypto-js/aes';
import Utf8 from 'crypto-js/enc-utf8';
/**
 * 默认存储前缀
 */

var PREFIX = 'backend-builder-';
/**
 * 本地数据存储操作服务
 *
 * 1. 以 key-value 方式存储
 * 2. 不支持时间等扩展对象
 * 3. 当某个 key 对应的 value 为 undefined 时（不包括 null），视为该条数据不存在。
 */

var LocalStorage = function () {
  /**
   * @param prefix 命名空间前缀，默认值为 backend-builder-
   * @param token 加密 token，默认为空，token 留空时不进行加密
   */
  function LocalStorage(prefix, token) {
    if (prefix === void 0) {
      prefix = PREFIX;
    }

    this.prefix = prefix;
    this.token = token;
  }
  /**
   * 获取服务新实例
   * @param prefix 命名空间前缀，默认值为 backend-builder-
   * @param token 加密 token，默认为空，token 留空时不进行加密
   * @returns 新实例
   */


  LocalStorage.prototype.getInstance = function (prefix, token) {
    return new LocalStorage(prefix, token);
  };
  /**
   * 判断数据是否存在
   * @param key 数据索引
   */


  LocalStorage.prototype.has = function (key) {
    return !!window.localStorage[this.prefix + key];
  };
  /**
   * 存储数据
   * @param key 数据索引
   * @param value 要存储的数据
   */


  LocalStorage.prototype.set = function (key, value) {
    var uKey = this.prefix + key;

    if (value !== undefined) {
      value = JSON.stringify(value);
      var encryptedValue = void 0;

      if (this.token) {
        encryptedValue = AES.encrypt(value, this.token);
      }

      window.localStorage[uKey] = encryptedValue || value;
    } else {
      localStorageInstance.remove(key);
    }
  };

  LocalStorage.prototype.get = function (key, defVal, storeDefVal) {
    var uKey = this.prefix + key,
        value = window.localStorage[uKey];

    if (value && this.token) {
      value = AES.decrypt(value, this.token).toString(Utf8);
    }

    return value ? JSON.parse(value) : (storeDefVal && defVal !== undefined && localStorageInstance.set(key, defVal), defVal);
  };
  /**
   * 移除数据
   * @param key  数据索引
   */


  LocalStorage.prototype.remove = function (key) {
    var uKey = this.prefix + key;
    delete window.localStorage[uKey];
  };

  return LocalStorage;
}();

var localStorageInstance = new LocalStorage();
export { localStorageInstance as localStorage };